import { render, staticRenderFns } from "./EmailConfirmationSuccess.vue?vue&type=template&id=5318c990&scoped=true&"
import script from "./EmailConfirmationSuccess.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmationSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318c990",
  null
  
)

export default component.exports